const getAppVersion = ({ prefix } = {}) => {
	const dev = 'dev';
	const version = process.env.REACT_APP_VERSION;
	if (!prefix) return version || dev;
	const versionDisplay = version ? `v${version}` : dev;
	return `${versionDisplay}`;
};

export default getAppVersion;
